/**
 * Common configuration file for contact information and organization details
 */

export interface ContactInfo {
  mobileNumber: string;
  supportEmail: string;
  organizationAddress: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
  phoneSupport: {
    number: string;
    availability: string;
  };
  liveChatAvailability: string;
  responseTime: {
    email: string;
    liveChat: string;
  };
}

export const CONTACT_INFO: ContactInfo = {
  mobileNumber: '+91 9663497150',
  supportEmail: 'admin@thesampark.com',
  organizationAddress: {
    street: '1006 Tower B,Ithum business Park, Sector 62',
    city: 'Noida',
    state: 'Uttar Pradesh',
    zipCode: '201309',
    country: 'India',
  },
  phoneSupport: {
    number: '+91 9663497150',
    availability: 'Mon-Fri, 10 AM - 8 PM IST',
  },
  liveChatAvailability: 'Available 24/7',
  responseTime: {
    email: 'Response within 24 hours',
    liveChat: 'Average response time: 2 minutes',
  },
};

export const FREE_PLAN_ID = 'ntrdRk8RmZ8HvDjQZJMBAzDYTrq1tuu7';
